import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { CONTACT, LEGAL } from "@/data/site";

const Row = ({ label, value }) => (
  <p><span className="text-forest font-medium">{label} :</span> {value}</p>
);

export default function Legal({ type }) {
  const isMentions = type === "mentions";
  return (
    <div data-testid={`legal-${type}`}>
      <Seo title={`${isMentions ? "Mentions légales" : "Politique de confidentialité"} — Sandro Services 06`} description="Informations légales et politique de confidentialité de Sandro Services 06." />
      <PageHero chapter="Informations" title={isMentions ? "Mentions légales" : "Politique de confidentialité"} />

      <section className="max-w-[820px] mx-auto px-6 md:px-12 py-12 md:py-20 space-y-8 text-ink-soft leading-relaxed">
        {isMentions ? (
          <>
            <div className="space-y-1">
              <h2 className="font-display text-2xl text-forest mb-3">Éditeur du site</h2>
              <Row label="Raison" value={LEGAL.raison} />
              <Row label="Statut" value={LEGAL.statut} />
              <Row label="SIRET" value={LEGAL.siret} />
              <Row label="RCS" value={LEGAL.rcs} />
              <Row label="Code APE" value={LEGAL.ape} />
              <Row label="TVA" value={LEGAL.tva} />
              <Row label="Adresse" value={LEGAL.address} />
              <Row label="Téléphone" value={CONTACT.phoneDisplay} />
              <Row label="E-mail" value={CONTACT.email} />
            </div>
            <div>
              <h2 className="font-display text-2xl text-forest mb-3">Hébergement</h2>
              <p>Ce site est hébergé par {LEGAL.host}.</p>
            </div>
            <div>
              <h2 className="font-display text-2xl text-forest mb-3">Propriété intellectuelle</h2>
              <p>L'ensemble des contenus de ce site est protégé. Toute reproduction sans autorisation est interdite.</p>
            </div>
          </>
        ) : (
          <>
            <div>
              <h2 className="font-display text-2xl text-forest mb-3">Données collectées</h2>
              <p>Les informations transmises via le formulaire de contact (nom, téléphone, e-mail, commune, description du projet et éventuelles photos) ainsi que les avis clients sont utilisés uniquement pour traiter votre demande et gérer les retours.</p>
            </div>
            <div>
              <h2 className="font-display text-2xl text-forest mb-3">Utilisation</h2>
              <p>Vos données ne sont ni vendues ni cédées à des tiers. Elles servent exclusivement à vous recontacter au sujet de votre demande. Les avis sont vérifiés avant publication.</p>
            </div>
            <div>
              <h2 className="font-display text-2xl text-forest mb-3">Vos droits</h2>
              <p>Vous pouvez demander l'accès, la rectification ou la suppression de vos données en nous contactant à {CONTACT.email}.</p>
            </div>
          </>
        )}
      </section>
    </div>
  );
}
